<template lang="pug">
  .collection-feed
    //- header
    header.min-h-132.md-min-h-164.flex.items-end.justify-center
      .text-19.md-text-26.pb-12.md-pb-20(v-if="hasHeader", v-html="collection.descriptionHtml")
    //- products
    section.bg-white.flex.flex-wrap(v-if="hasProducts")
      //- items...
      article.w-1x2.md-w-1x3.lg-w-1x4(v-for="(item, ii) in collection.products")
        router-link.block.relative(:to="{name: 'collection__product', params: { slug: slug || collection.handle, handle: item.handle }}")
          figure.bg-gray-100.pb-150pct
            resp-img.blend-multiply(v-if="item.images[0]", :bg="true", :useHeight="true", :lazy="true", :src="item.images[0].src", :alt="item.images[0].alt", bgClass="blend-multiply bg-cover bg-bottom")
          header.absolute.bottom-0.left-0.w-full.p-10.text-9.uppercase.leading-snug.text-white(style="mix-blend-mode:difference;")
            //- h6(v-if="item.productType !== 'Pre-Order'") {{ item.productType }}
            h6 {{ item.title }}
            div
              //- available
              template(v-if="base(item).avail")
                //- compare at
                span.inline-block.mr-6.text-gray-500.line-through(v-if="base(item).reduced")
                  | {{ base(item).compareAt }}
                //- current price
                span(:class="{'text-red': base(item).reduced }") {{ base(item).price }}
              //- sold out !
              template(v-else)
                span.text-gray-500
                  | {{ base(item).msg }}
</template>

<script>
import { mapGetters } from 'vuex'
import { getDefaultVariant } from '@/utils'
import RespImg from '@/components/RespImg'
import NewsletterPopup from '@/components/modals/NewsletterPopup'
export default {
  props: ['id', 'slug'],
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters(['price', 'winIs']),
    collection () {
      // Shopify Collection
      return this.id && this.$store.state.collections[this.id]
    },
    hasHeader () {
      return this.collection && this.collection.description.length
    },
    hasProducts () {
      return !this.loading && this.collection && this.collection.products.length
    }
  },
  methods: {
    base (item) {
      // cheapest variant
      return this.price(getDefaultVariant(item)) // price data
    }
  },
  created () {
    this.$store.dispatch('getCollection', this.id).then(() => {
      this.loading = false
      this.$emit('loaded')
    })
  },
  components: { RespImg, NewsletterPopup }
}
</script>

<style>
</style>
